import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate and Link
import Tabs from "../../Common/misc/Tabs";

import InvocationsList from "./Components/Invocations";
import { getIntegrationById } from "../../Common/services/httpservice";

import tabsList from "@Common/data/details-tabs.json";

// https://www.creative-tim.com/twcomponents/component/table-with-filter-and-search

const Invocations = () => {
  // const scrollAnimation = useMemo(() => getScrollAnimation(), []);
  //   const router = useRouter(); // Initialize the router
  const [integrationDetails, setIntegrationDetails] = useState({});

  const [isRunning, setIsRunning] = useState(true);

  const handleStop = () => {
    setIsRunning(!isRunning);
  };


  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await getIntegrationById(id);
        // console.log(data);
        if (data) {
          setIntegrationDetails(data); // Update the state with the fetched data
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]); // Empty dependency array means this runs once on mount

  const navigate = useNavigate(); // Get the navigate function

  const handleGoToDashboard = () => {
    // router.back();
    navigate(`/integrations/listing`);
  };

  const handleGotoHome = () => {
    navigate("/");
  };

  const handleGoNext = () => {
    navigate(`/integrations/${id}/source`); // Navigate to the next page
  };

  const onTabSelected = (pageName) => {
    navigate(`/integrations/${id}/${pageName}`);
  };

  const handleDelete = () => {
    console.log("Delete");
  };

  const handleEdit = () => {
    navigate(`/integrations/${id}/overview`);

  };

  //   const [activeLink, setActiveLink] = useState(null);
  //   const [scrollActive, setScrollActive] = useState(false);

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     setScrollActive(window.scrollY > 20);
  //   });
  // }, []);

  return (
    <div className="mx-auto mt-16 pt-6 px-12 bg-theme-primary">
      <section className="">
        <div className="sm:flex sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center gap-x-3">
              

              <button
                onClick={handleGoToDashboard}
                title="Dashboard"
                className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2.5 text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
              >
                <svg className="h-5 w-6" viewBox="0 -4.5 31 31" version="1.1" fill="#000000">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round"
                    strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                    <desc>Created with Sketch Beta.</desc> <defs> </defs>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Icon-Set-Filled"
                        transform="translate(-206.000000, -626.000000)" fill="#000000">
                        <path d="M235,643 L216,643 C214.896,643 214,643.896 214,645 C214,646.104 214.896,647 216,647 L235,647 C236.104,647 237,646.104 237,645 C237,643.896 236.104,643 235,643 L235,643 Z M235,635 L216,635 C214.896,635 214,635.896 214,637 C214,638.104 214.896,639 216,639 L235,639 C236.104,639 237,638.104 237,637 C237,635.896 236.104,635 235,635 L235,635 Z M216,631 L235,631 C236.104,631 237,630.104 237,629 C237,627.896 236.104,627 235,627 L216,627 C214.896,627 214,627.896 214,629 C214,630.104 214.896,631 216,631 L216,631 Z M209,642 C207.343,642 206,643.343 206,645 C206,646.657 207.343,648 209,648 C210.657,648 212,646.657 212,645 C212,643.343 210.657,642 209,642 L209,642 Z M209,634 C207.343,634 206,635.343 206,637 C206,638.657 207.343,640 209,640 C210.657,640 212,638.657 212,637 C212,635.343 210.657,634 209,634 L209,634 Z M209,626 C207.343,626 206,627.343 206,629 C206,630.657 207.343,632 209,632 C210.657,632 212,630.657 212,629 C212,627.343 210.657,626 209,626 L209,626 Z" id="list" > </path> </g> </g> </g></svg>
              </button>


            <button
              onClick={handleEdit}
              className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-gray-200 px-2 py-2 text-sm text-gray-800 transition-colors duration-200 hover:bg-gray-400 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                    stroke="#000000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                </g>
              </svg>
            </button>

              <h2 className="dark:text-white text-lg font-medium text-white">
                {isLoading ? (
                  <div className="my-1 animate-pulse">
                    <div className="h-8 w-80 rounded-full bg-gray-200 dark:bg-gray-700">
                    </div>
                  </div>
                ) : (
                  integrationDetails && integrationDetails.name ? <div className="w-80">{integrationDetails.name}</div> : <div className="w-80">&nbsp;</div>
                )}
              </h2>

              <div className="rounded-full px-3 py-0 text-xs">
                <Tabs tabsList={tabsList} selectedIndex={1} interactive={true} onTabSelected={onTabSelected} />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end gap-x-2">
            {" "}

            {isRunning &&
              <div className="flex whitespace-nowrap rounded-lg bg-green-200">
                <div className="px-2 pt-1 text-green-800">{integrationDetails && integrationDetails.status}</div>
                <button
                  onClick={handleStop}
                  className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-red-500 px-2 py-2 text-sm text-white-500 transition-colors duration-200 hover:bg-red-600 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
                >
                  Stop
                </button>
              </div>
            }
            {!isRunning &&
              <div className="flex whitespace-nowrap rounded-lg bg-red-200">
                <div className="px-2 pt-1 text-red-800">Stopped</div>
                <button
                  onClick={handleStop}
                  className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-green-500 px-2 py-2 text-sm text-white-500 transition-colors duration-200 hover:bg-green-600 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
                >
                  Start
                </button>
              </div>
            }

            {/* <span className="w-4">&nbsp;</span>
            <button
              onClick={handleDelete}
              className="flex w-1/2 items-center justify-center gap-x-2 rounded-lg bg-red-500 px-2 py-2 text-sm text-white-500 transition-colors duration-200 hover:bg-red-600 sm:w-auto dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              Delete
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M10 11V17"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M14 11V17"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M4 7H20"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                </g>
              </svg>
            </button> */}
          </div>
        </div>
        <div className="mt-4">
          <InvocationsList details={integrationDetails} isLoading={isLoading} error={error} />
        </div>
      </section>
    </div>
  );
};

export default Invocations;
